export const isUnallowedPairing = (
  a: number,
  b: number,
  unallowedAdjacentColors: { [key: string]: string[] }
) =>
  a === b ||
  unallowedAdjacentColors[`${a}`]?.includes(`${b}`) ||
  unallowedAdjacentColors[`${b}`]?.includes(`${a}`);
